export default __webpack_public_path__ + "static/media/CoinLogoWithText2.fc711cc7.png";